import { useRouter } from 'found';
import React, { useEffect, useState } from 'react';
import EventList from 'containers/EventList';
import { useApolloClient, useMutation, useQuery } from '@apollo/client';
import CommunityPage from './Page';
import { GET_EVENT_SEARCH } from '../../schema/apolloQueries/communityDetailsQueries';
import { GET_PROFILE_INFO } from '../../schema/apolloQueries/commonQueries';
import {
  JOIN_LEAVE_SPONSOR,
  LIKED_UNLIKED_SPONSOR,
} from '../../schema/apolloMutations/eventDeatilsMutations';
import InfiniteScrollApp from '../../components/InfiniteScrollerApollo';
import SponsorMessage from './SponsorMessage';

const pageSize = 25;

const CommunityEventsPage = () => {
  const [isAlert, setAlert] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const {
    router,
    match: {
      params: { communitySlug },
    },
  } = useRouter();
  const [eventData, setEventData] = useState();

  const client = useApolloClient();

  const profileData = client.readQuery({
    query: GET_PROFILE_INFO,
  });

  const { data, fetchMore, error, loading } = useQuery(GET_EVENT_SEARCH, {
    variables: {
      pageNo: 1,
      pageSize,
      sponsorSlug: encodeURIComponent(communitySlug),
    },
  });

  useEffect(() => {
    if (
      !loading
      && error
      && JSON.parse(error?.message)
      && JSON.parse(error?.message)?.status === 'NOT_FOUND'
    ) {
      setAlert(true);
    }
  }, [loading, error]);

  useEffect(() => {
    setEventData(data);
    if (Array.isArray(data?.getSponsorEvents?.data)) {
      setIsFirstLoad(false);
    }
  }, [data]);

  const [handleLike] = useMutation(LIKED_UNLIKED_SPONSOR, {
    variables: {
      model: 'event',
    },
  });

  const [handleJoin] = useMutation(JOIN_LEAVE_SPONSOR, {
    refetchQueries: [GET_EVENT_SEARCH],
  });

  const handleFetchMore = (isPage, setHasMore) => {
    return new Promise((reslove, reject) => {
      fetchMore({
        variables: {
          pageNo: isPage,
          pageSize,
        },
        updateQuery: (pre, { fetchMoreResult }) => {
          if (
            pre?.getSponsorEvents.data?.length
            >= fetchMoreResult?.getSponsorEvents?.total
          ) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
          return pre?.getSponsorEvents.events?.length
            >= fetchMoreResult?.getSponsorEvents?.total
            ? pre
            : {
                getSponsorEvents: {
                  __typename: pre.getSponsorEvents.__typename,
                  total: pre.getSponsorEvents.total,
                  data: [
                    ...pre.getSponsorEvents.data,
                    ...fetchMoreResult.getSponsorEvents.data,
                  ],
                },
              };
        },
      })
        .then(() => {
          reslove();
        })
        .catch(() => {
          reject();
        });
    });
  };

  if (isAlert) {
    return (
      <SponsorMessage
        open={isAlert}
        onClick={() => {
          window.location.replace('/discover/communities');
        }}
      />
    );
  }

  return (
    <CommunityPage
      handleLike={handleLike}
      community={data?.fetchSponsorDetails}
      title='Events'
      viewer={profileData?.getProfile}
      handleJoin={handleJoin}
    >
      {eventData?.getSponsorEvents?.data && (
        <InfiniteScrollApp
          handleFetchMore={handleFetchMore}
          isFirstLoad={isFirstLoad}
          doneText='Be sure to check back soon for new events!'
          isEmpty={data?.getSponsorEvents?.data?.length === 0}
          emptyText='Check back soon for new events, or click here to discover events in other communities'
          emptyTitle="This community isn't hosting any events right now!"
          onEmptyClick={() => router.push('/discover/events')}
        >
          <EventList
            setEventData={setEventData}
            data={eventData}
            handleLike={handleLike}
            eventConnection={eventData?.getSponsorEvents?.data}
            viewer={profileData?.getProfile}
          />
        </InfiniteScrollApp>
      )}
    </CommunityPage>
  );
};

export default CommunityEventsPage;
